module.exports = __webpack_public_path__ + "static/media/bidwells1.4f74c616.png";